// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"238": "__federation_expose_AdvertiserAccessGate","259": "__federation_expose_OrderCard","438": "__federation_expose_FlightDeckProvider","56": "__federation_expose_Styles","755": "__federation_expose_Dashboard","879": "__federation_expose_ImpressionAssignmentForm",}[chunkId] || chunkId) + ".bundle.js"
}